// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Vmak","actions":"styles_actions__5B_cN","error":"styles_error__10K0x","message":"styles_message__bEnga"};